export default __webpack_public_path__ + "9b0986037074957beea5b47856645e86.svg";